import React, { createContext, useContext } from 'react';

/**
 * Props forwarded from the legacy ObjectBadge into an app-provided override.
 * Matches the subset shared by PlatformObjectBadge / AdminObjectBadge.
 */
export interface ObjectBadgeOverrideProps {
    id?: string;
    entityType: string;
    display?: string;
    className?: string;
    disableClick?: boolean;
    hideIcon?: boolean;
    clearable?: {
        onClear: () => void;
    };
    overwriteDisplayMap?: (entity: any) => string;
    styles?: {
        icon?: string;
    };
}

export type ObjectBadgeOverride = (props: ObjectBadgeOverrideProps) => React.ReactElement | null;

const ObjectBadgeOverrideContext = createContext<ObjectBadgeOverride | null>(null);

/**
 * When provided, the legacy ObjectBadge renders the override instead of its own UI.
 * Admin uses this so shared-lib surfaces (detail fields, list cells, filters) get AdminObjectBadge.
 * Platform / mobile / kiosk leave this unset and keep legacy behavior.
 */
export function ObjectBadgeOverrideProvider(props: { override: ObjectBadgeOverride; children: React.ReactNode }) {
    return <ObjectBadgeOverrideContext.Provider value={props.override}>{props.children}</ObjectBadgeOverrideContext.Provider>;
}

export function useObjectBadgeOverride(): ObjectBadgeOverride | null {
    return useContext(ObjectBadgeOverrideContext);
}
